// extracted by mini-css-extract-plugin
export default {"container":"Results_container__MYGR7"};